import {
  Accordion,
  Button,
  ButtonLayout,
  Layout,
  Modal,
  Radio,
  RadioGroup,
  TagFilter,
  TagFilterGroup,
  Title,
  Spacer
} from "@common/AggregationComponent";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { SelectedGender } from "@type/index";
import { getEcRenewalCompatibility, handleHeightLabel } from "@util/common";

export interface FilterModelArgs {
  visibleFilter: boolean;
  visible: boolean;
  total: number | string;
  genders: any[];
  heights: any[];
  visibleGender: boolean;
  visibleHeight: boolean;
  searchGender: string;
  searchHeight: string;
  selectedGender: SelectedGender;
  selectedHeight: any;
  onChangeSelected: (
    gender: SelectedGender,
    height: any,
    chooseGender: boolean
  ) => void;
  handlerGenderExpand: () => void;
  handlerHeightExpand: () => void;
  onClose: () => void;
}

const FilterModel = (props: FilterModelArgs) => {
  const {
    visibleFilter,
    visible,
    total,
    genders,
    heights,
    visibleGender,
    visibleHeight,
    selectedGender,
    selectedHeight,
    onChangeSelected,
    handlerGenderExpand,
    handlerHeightExpand,
    onClose
  } = props;
  const { t } = useTranslation();

  const handlerClearAll = () => {
    onChangeSelected("All", "", false);
  };
  const getSelectedTags: any[] = useMemo(() => {
    const newSelectedTags = [];
    if (selectedGender !== "All") {
      newSelectedTags.push(selectedGender);
    }
    if (selectedHeight) {
      newSelectedTags.push(selectedHeight);
    }
    return newSelectedTags;
  }, [selectedGender, selectedHeight]);

  const handlerDeleteTag = (tag: any) => {
    if (tag === selectedGender) {
      handlerClearAll();
    } else if (tag.label === selectedHeight.label) {
      onChangeSelected(selectedGender, "", false);
    }
  };

  return (
    <Layout
      colSpan={{ lg: 6, md: 12, sm: 4 }}
      visible={{
        lg: false,
        md: true,
        sm: true
      }}
    >
      <Modal
        closeLabel={getEcRenewalCompatibility() ? " " : t("text_close")}
        closeTitle={t("text_close")}
        errors={[]}
        id="sm-1"
        labelElement="h5"
        onBackdropClick={undefined}
        onRequestClose={onClose}
        title={t("text_filter")}
        titleId="modal-title"
        itemCount={`${t("text_image_search_result_number", { total: total })}`}
        trapFocus
        variant="filter"
        isOpen={visible}
        footer={
          <ButtonLayout reverseOnVertical={false} variant="fluid">
            <Button
              element="button"
              isSmall={false}
              variant="primary"
              width="fullWidth"
              onClick={onClose}
            >
              {t("text_apply_search_filter")}
            </Button>
          </ButtonLayout>
        }
      >
        <Spacer element="div" variant={"spacing-05"} />
        {getSelectedTags.length > 0 && (
          <div className="fr-ec-mb-spacing-04">
            <Title
              color="primary-dark"
              element="h1"
              textAlign="left"
              textTransform="title-case"
              variant="large"
              className="fr-ec-mb-spacing-04"
            >
              {t("text_active_filters")}
            </Title>
            <TagFilterGroup
              clearLabel={t("text_image_search_clear_all_filters")}
              onClear={handlerClearAll}
            >
              {getSelectedTags.map((tag: any) => {
                if (typeof tag === "string") {
                  return (
                    <TagFilter
                      disabled={false}
                      value={tag}
                      key={tag}
                      onClick={() => {
                        handlerDeleteTag(tag);
                      }}
                    />
                  );
                } else {
                  return (
                    <TagFilter
                      disabled={false}
                      value={handleHeightLabel(tag, t)}
                      key={tag.value}
                      onClick={() => {
                        handlerDeleteTag(tag);
                      }}
                    />
                  );
                }
              })}
            </TagFilterGroup>
          </div>
        )}

        <Accordion
          disabled={false}
          element="div"
          id="accordion-id"
          label={t("text_gender")}
          labelChildren=""
          labelElement="h1"
          onClose={handlerGenderExpand}
          onExpand={handlerGenderExpand}
          variant="small"
          expanded={visibleGender}
          // expanded={getSelectedTags.length > 0}
        >
          <RadioGroup columnCount={{ sm: 2, md: 2, lg: 1 }}>
            {visibleFilter ? (
              <></>
            ) : (
              genders.map((gender: any) => (
                <Radio
                  checked={gender.name === selectedGender}
                  id={`height-gender-${gender.id}`}
                  key={gender.id}
                  label={gender.name}
                  name="gender-radio"
                  onChange={() => {
                    onChangeSelected(gender.name, selectedHeight, true);
                  }}
                  value={gender.id}
                />
              ))
            )}
          </RadioGroup>
        </Accordion>
        <Accordion
          disabled={false}
          element="div"
          id="accordion-id"
          label={t("text_height")}
          labelChildren=""
          labelElement="h1"
          onClose={handlerHeightExpand}
          onExpand={handlerHeightExpand}
          variant="small"
          expanded={visibleHeight}
          className="fr-ec-mb-spacing-06"
        >
          <RadioGroup columnCount={{ sm: 2, md: 2, lg: 1 }}>
            {visibleFilter ? (
              <></>
            ) : (
              heights.map((height: any) => (
                <Radio
                  checked={height.value === selectedHeight.value}
                  id={`height-raido-${height.value}`}
                  key={height.key}
                  label={handleHeightLabel(height, t)}
                  name="height-radio"
                  onChange={() => {
                    onChangeSelected(selectedGender, height, false);
                  }}
                  value={height.value}
                />
              ))
            )}
          </RadioGroup>
        </Accordion>
      </Modal>
    </Layout>
  );
};
export default FilterModel;
